import React, { Component} from 'react';

import { useState, useEffect,useRef } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faBath, faCamera, faImages, faMapMarkedAlt, faListAlt} from '@fortawesome/free-solid-svg-icons'; // Importation des icônes

import axios from 'axios';
import './shop-grid.css';
import './PropertyList.css';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

import Slider from "rc-slider";

import { useMemo } from "react";
import NavbarV2 from '../global-components/navbar-v2';


const ResultsPagebox = () => {
	const [products, setProducts] = useState([]);
	const navigate = useNavigate(); // Hook pour naviguer
	const handleProductClick = (productId) => navigate(`/product-details/${productId}`);
	const handleImageClick = (productId) => navigate(`/property-images/${productId}`);
      const [totalProperties, setTotalProperties] = useState(0);
  
	const propertiesPerPage = 12;
	const [currentPage, setCurrentPage] = useState(1);
	const [activeTab, setActiveTab] = useState('galerie');
	const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const location = useLocation();
  const filterss = location.state || {};
  const [properties, setProperties] = useState([]);
  const [isPriceFilterOpen, setIsPriceFilterOpen] = useState(false); // État pour ouvrir/fermer la carte
  const [priceRange, setPriceRange] = useState(location.state?.priceRange || [10000, 990000000]); // Récupère ou initialise la plage de prix

    const [loading, setLoading] = useState(false);
  

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions([]); // Ne pas faire de requêtes si l'entrée est trop courte
      return;
    }

    const fetchSuggestions = async () => {
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/search-predictive', {
          params: { query },
        });
        setSuggestions(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des suggestions', error);
      }
    };

    fetchSuggestions();
  }, [query]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

	// Effet pour récupérer les produits depuis le backend
	useEffect(() => {
	  // Fonction pour récupérer les produits
	  const fetchProducts = async () => {
		try {
		  const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/products');  // URL de votre backend
		  setProducts(response.data);  // Met à jour l'état avec les produits récupérés
		} catch (error) {
		  console.error('Erreur lors de la récupération des produits:', error);
		}
	  };
  
	  fetchProducts();  // Appel de la fonction pour récupérer les produits
	}, []);  // Le tableau vide [] indique que l'effet s'exécute une seule fois lors du montage du composant
  
	const [category, setCategory] = useState("Résidentiel");
	const [transactionType, setTransactionType] = useState("À vendre");
	const [price, setPrice] = useState("");
	const [lifestyleFilters, setLifestyleFilters] = useState(1);
	const { searchTerm } = useParams();
    const [sortMethod, setSortMethod] = useState("relevance"); // Valeur par défaut
  

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/products', {
          params: { search: searchTerm },
        });
        setProducts(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des résultats', error);
      }
    };

    fetchResults();
  }, [searchTerm]);
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/products", {
          params: {
            minPrice: priceRange[0], // Filtre par prix minimum
            maxPrice: priceRange[1], // Filtre par prix maximum
          },
        });
        setProducts(response.data); // Met à jour l'état avec les données reçues
      } catch (error) {
        console.error("Erreur lors de la récupération des produits :", error);
      }
    };
  
    fetchProducts();
  }, [priceRange, sortMethod]); 
  

  const fetchSortedProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/sorts', {
        params: { sort: sortMethod },
      });
      setProducts(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des produits triés :", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSortedProducts();
  }, [sortMethod]);
  const filteredProducts = products.filter(
		(product) => product.transactionType === 'sale'
	);
  const filteredAndSortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortMethod === "price_asc") {
      return a.price - b.price;
    } else if (sortMethod === "price_desc") {
      return b.price - a.price;
    } else {
      return new Date(b.publicationDate) - new Date(a.publicationDate); // Par défaut : tri par date récente
    }
  });
	// Filtrer les produits pour afficher uniquement ceux à vendre
	
	const handlePageChange = (page) => {
        setCurrentPage(page);
    };
        let publicUrl = process.env.PUBLIC_URL+'/'

		const handleCardClick = async (item) => {
			try {
			  navigate(`/results/${encodeURIComponent(item)}`); // Redirection avec l'élément sélectionné
			} catch (error) {
			  console.error("Erreur lors de la redirection :", error);
			}
		  };

      // useEffect(() => {
      //   const fetchFilteredProducts = async () => {
      //     try {
      //       console.log("Filtres envoyés :", filters);
      //       const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/apprt", {
      //         params: { productType: filters.productType || "" },
      //       });
      
      //       setProperties(response.data);
      //     } catch (error) {
      //       console.error("Erreur lors de la récupération des produits filtrés :", error);
      //     }
      //   };
      
      //   fetchFilteredProducts();
      // }, [filters]);
      
  const [results, setResults] = useState([]);
  console.log("🔍 Paramètre reçu dans ResultsPagebox :", searchTerm);
  useEffect(() => {
    const fetchResults = async () => {
      try {
        const response = await fetch(`https://keurgui-backend-kjour.ondigitalocean.app/api/checkbox?productType=${searchTerm}`); // Filtre par productType
        const data = await response.json();
        setResults(data);
      } catch (error) {
        console.error("Erreur lors du chargement des résultats :", error);
      }
    };

    fetchResults();
  }, [searchTerm]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  
  const handleToggleFilterModal = () => {
    setIsFilterModalOpen(!isFilterModalOpen);
  };
const [isPropertyTypeOpen, setIsPropertyTypeOpen] = useState(false); // État pour afficher les cases à cocher

  const handleTogglePropertyType = () => {
    setIsPropertyTypeOpen(!isPropertyTypeOpen);
  };
  const [isCharacteristicsOpen, setIsCharacteristicsOpen] = useState(false); // État pour afficher les caractéristiques

  const handleToggleCharacteristics = () => {
    setIsCharacteristicsOpen(!isCharacteristicsOpen);
  };

  const [isBuildingOpen, setIsBuildingOpen] = useState(false); // État pour afficher les détails du bâtiment
  
    const handleToggleBuilding = () => {
      setIsBuildingOpen(!isBuildingOpen);
    };

     const [isOtherCriteriaOpen, setIsOtherCriteriaOpen] = useState(false); // État pour afficher les autres critères

      const handleToggleOtherCriteria = () => {
        setIsOtherCriteriaOpen(!isOtherCriteriaOpen);
      };
      useEffect(() => {
        const fetchProperties = async () => {
          try {
            const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/products", {
              params: { transactionType: "À vendre" },
            });
            setProperties(response.data);
          } catch (error) {
            console.error("Erreur lors de la récupération des propriétés :", error);
          }
        };
      
        fetchProperties();
      }, []);
// ----------------------------------------------------------------------------------------------------F----------------------     

   
const [selectedProductType, setSelectedProductType] = useState(""); // Uniquement pour productType

  const handleFilterChange = (e) => {
    setSelectedProductType(e.target.value); // Met à jour la sélection
  };

 
  const [searchParams] = useSearchParams();
const decodedSearchTerm = searchTerm ? decodeURIComponent(searchTerm) : ""; // Évite une erreur si `searchTerm` est `undefined`


  const filters = {};
  if (searchTerm && searchTerm !== "all") {
    decodeURIComponent(searchTerm).split("&").forEach(param => {
      const [key, value] = param.split("=");
      if (key && value) {
        filters[key] = value.split(","); // Convertit "types=appartement,villa_maison" en { types: ["appartement", "villa_maison"] }
      }
    });
  }

  console.log("✅ Filtres extraits :", filters); // Vérification

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const queryParams = new URLSearchParams();

        if (filters.types) {
          queryParams.append("types", filters.types.join(","));
        }
        if (filters.structureTypes) {
          queryParams.append("structureTypes", filters.structureTypes.join(","));
        }

        console.log("📡 Envoi requête API :", `https://keurgui-backend-kjour.ondigitalocean.app/api/results?${queryParams.toString()}`);

        const response = await fetch(`https://keurgui-backend-kjour.ondigitalocean.app/api/results?${queryParams.toString()}`);
        const data = await response.json();

        console.log("✅ Résultats reçus :", data); // Voir si les résultats sont bien reçus
        setResults(data);
      } catch (error) {
        console.error("❌ Erreur lors de la récupération des résultats :", error);
      }
    };

    fetchResults();
  }, [searchTerm]);


const searchFilters = useMemo(() => {
  const filters = {};
  if (searchTerm && searchTerm !== "all") {
    decodeURIComponent(searchTerm).split("&").forEach(param => {
      const [key, value] = param.split("=");
      if (key && value) {
        filters[key] = value;
      }
    });
  }
  return filters;
}, [searchTerm]);

  
  console.log("✅ Filtres extraits :", searchFilters);
  
  useEffect(() => {
    if (!searchTerm || searchTerm === "all") {
      console.log("🚫 Aucun filtre appliqué, requête API annulée.");
      return; // 🔥 Ne fait pas d'appel API si aucun filtre
    }
  
    console.log("🔄 useEffect exécuté avec searchTerm :", searchTerm);
  
    const fetchResults = async () => {
      try {
        const queryParams = new URLSearchParams();
  
        if (searchFilters.minLotSize) {
          queryParams.append("minLotSize", searchFilters.minLotSize);
        }
        if (searchFilters.maxLotSize) {
          queryParams.append("maxLotSize", searchFilters.maxLotSize);
        }
        if (searchFilters.minDate) {
          queryParams.append("minDate", searchFilters.minDate);
        }
  
        const apiUrl = `https://keurgui-backend-kjour.ondigitalocean.app/api/ters?${queryParams.toString()}`;
        console.log("📡 Envoi requête API :", apiUrl);
  
        const response = await fetch(apiUrl);
        const data = await response.json();
  
        console.log("✅ Résultats reçus :", data);
        setResults(data);
      } catch (error) {
        console.error("❌ Erreur lors de la récupération des résultats :", error);
      }
    };
  
    fetchResults();
  }, [searchTerm]);
  
// ---------------------------------------------------------------------------------------------------  
const [minLotSize, setMinLotSize] = useState("");
  const [maxLotSize, setMaxLotSize] = useState("");
  const [minDate, setMinDate] = useState("");
    const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
    const [isResidentialOpen, setIsResidentialOpen] = useState(false); // État pour le dropdown Résidentiel
  const [isRentOpen, setIsRentOpen] = useState(false); // État pour le dropdown Louer
  
  const residentialDropdownRef = useRef(null);
  const rentDropdownRef = useRef(null);
  
  const handleResidentialClick = () => {
    setIsResidentialOpen(!isResidentialOpen);
    setIsRentOpen(false); // Fermer le dropdown Louer si ouvert
  };
  
  const handleRentClick = () => {
    setIsRentOpen(!isRentOpen);
    setIsResidentialOpen(false); // Fermer le dropdown Résidentiel si ouvert
  };
  
  const handleClickOutside = (event) => {
    if (
      residentialDropdownRef.current &&
      !residentialDropdownRef.current.contains(event.target)
    ) {
      setIsResidentialOpen(false);
    }
    if (
      rentDropdownRef.current &&
      !rentDropdownRef.current.contains(event.target)
    ) {
      setIsRentOpen(false);
    }
  };
  const [isOpen, setIsOpen] = useState(false); // État pour ouvrir/fermer le dropdown
    const dropdownRef = useRef(null); // Référence au menu déroulant
  
  const handleOptionClick = (route) => {
    setIsOpen(false); // Ferme le dropdown après le clic
    navigate(route); // Redirige vers la page correspondante
  };
  const cardRef = useRef(null); // Référence pour détecter les clics
  
 useEffect(() => {
    function handleClickOutside(event) {
      if (cardRef.current && !cardRef.current.contains(event.target)) {
        setIsPriceFilterOpen(false); // Ferme la carte
      }
    }

    // Ajouter l'écouteur de clic lorsqu'on ouvre le filtre
    if (isPriceFilterOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPriceFilterOpen]);
  //   ---------------------------nouv--------------
    
  const handleApplyFilter = async () => {
    try {
      console.log("Application du filtre avec la plage de prix :", priceRange);
  
      // Requête API pour récupérer les propriétés filtrées
      const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/filtre", {
        params: {
          minPrice: priceRange[0], // Prix minimum
          maxPrice: priceRange[1], // Prix maximum
          transactionType: "rent", // Assurez-vous que le type de transaction est correct
        },
      });
  
      // Mise à jour de l'état avec les nouvelles propriétés
      setProducts(response.data);
      setIsPriceFilterOpen(false); // Fermer le filtre après application
    } catch (error) {
      console.error("Erreur lors de l'application du filtre :", error);
    }
  };

   const filterModalRef = useRef(null); // Référence du modal
  
    // Fonction pour détecter un clic en dehors du modal et fermer
    useEffect(() => {
      function handleClickOutside(event) {
        if (filterModalRef.current && !filterModalRef.current.contains(event.target)) {
          setIsFilterModalOpen(false);
        }
      }
  
      // Ajouter l'écouteur de clic lorsqu'on ouvre le modal
      if (isFilterModalOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isFilterModalOpen]);
  
  
    // Fonction pour détecter un clic en dehors de la carte
    useEffect(() => {
      function handleClickOutside(event) {
        if (cardRef.current && !cardRef.current.contains(event.target)) {
          setIsPriceFilterOpen(false); // Ferme la carte
        }
      }
  
      // Ajouter l'écouteur de clic lorsqu'on ouvre le filtre
      if (isPriceFilterOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isPriceFilterOpen]);

 const [selectedStructureTypes, setSelectedStructureTypes] = useState([]); // 🔥 Déclaration ici
      
        const handlePropertyTypeChange = (type) => {
          setSelectedPropertyTypes((prevTypes) =>
            prevTypes.includes(type)
              ? prevTypes.filter((t) => t !== type)
              : [...prevTypes, type]
          );
        };
        const handleStructureTypeChange = (event) => {
          const value = event.target.value;
          setSelectedStructureTypes((prev) =>
            prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
          );
        };
      
        const handleSearch = () => {
          let searchTerms = [];
        
          if (selectedPropertyTypes.length > 0) {
            searchTerms.push(`types=${selectedPropertyTypes.join(",")}`);
          }
        
          if (selectedStructureTypes.length > 0) {
            searchTerms.push(`structureTypes=${selectedStructureTypes.join(",")}`);
          }
        
          // Si aucun filtre n'est appliqué, passer "all"
          const searchQuery = searchTerms.length > 0 ? searchTerms.join("&") : "all";
        
          // Encoder pour éviter les erreurs d'URL
          const targetUrl = `/resultss/${encodeURIComponent(searchQuery)}`;
        
          console.log("🔍 Naviguer vers :", targetUrl);
          navigate(targetUrl);
        };
        
        const handleSearch1 = () => {
          let searchTerms = [];
        
          // 🔹 Superficie du terrain
          if (minLotSize) {
            searchTerms.push(`minLotSize=${minLotSize}`);
          }
          if (maxLotSize) {
            searchTerms.push(`maxLotSize=${maxLotSize}`);
          }
        
          // 🔹 Date d'ajout
          if (minDate) {
            searchTerms.push(`minDate=${minDate}`);
          }
        
          // 🔥 Si aucun critère avancé n'est sélectionné, passer "all"
          const searchQuery = searchTerms.length > 0 ? searchTerms.join("&") : "all";
        
          // 🔹 Encoder l'URL et naviguer vers `ResultsPage`
          const targetUrl = `/results/${encodeURIComponent(searchQuery)}`;
        
          console.log("🔍 URL générée :", targetUrl);
          navigate(targetUrl);
        };
        
        const handleResetFilters = () => {
          setSelectedPropertyTypes([]); // Réinitialiser les types d'habitat sélectionnés
          setSelectedStructureTypes([]); // Réinitialiser les caractéristiques
          setMinLotSize(""); // Réinitialiser la superficie minimale
          setMaxLotSize(""); // Réinitialiser la superficie maximale
          setMinDate(""); // Réinitialiser la date minimale
        };
       
        useEffect(() => {
          // Fonction pour récupérer le total des produits
          const fetchTotalProducts = async () => {
            try {
              const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/products/count'); // Utilisez le bon chemin
              setTotalProperties(response.data.total); // Met à jour l'état avec le total récupéré
            } catch (error) {
              console.error('Erreur lors de la récupération du total des produits :', error);
            }
          };
        
          fetchTotalProducts(); // Appel de la fonction pour récupérer le total
        }, []); // Exécuté uniquement au montage
 
 	return(
		
		
		 <div>
      <NavbarV2 />
			<div className="ltn__product-area ltn__product-gutter mb-100">
				<div className="container">
						<div className="row">
							<div className="col-lg-12">
							
							<div className="tab-content ">
								<div className="tab-pane fade active show" id="liton_product_grid">
								<div className="ltn__product-tab-content-inner ltn__product-grid-view">
									<div className="row">
									<div className="col-lg-12">
									{/* Search Widget */}
									<div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
										{/* Barre de recherche */}
										
										<input
										type="text"
										placeholder="Chercher par ville, quartier, région, adresse ou N° Keurgui"
										value={query}
										onChange={(e) => setQuery(e.target.value)}
										className="input-style"
										
										/>
										 {/* Résultats de la recherche prédictive sous forme de cartes */}
 				

										{/* Catégorie */}
										<div ref={residentialDropdownRef} style={{ position: "relative", display: "inline-block" }}>
  <button
    onClick={handleResidentialClick}
    style={{
      padding: "10px 20px",
      backgroundColor: "white",
      color: "black",
      border: "none",
      borderRadius: "30px", // Ajout d'une bordure arrondie
      cursor: "pointer",
      display: "flex",
      border: "1px solid #ddd",
      alignItems: "center",
      gap: "10px", // Espace entre le texte et l'icône
    }}
  >
    Résidentiel
    <span
  style={{
    transform: isResidentialOpen ? "rotate(180deg)" : "rotate(0deg)",
    fontWeight: "300", // Plus léger
    fontSize: "12px", // Plus petit
    lineHeight: "1", // Ajuster la hauteur de ligne
  }}
>
  ▼
</span>
    </button>
  {isResidentialOpen && (
    <ul
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        backgroundColor: "white",
        padding: "10px",
        border: "1px solid #ddd",
        zIndex: 1000,
        listStyleType: "none", // Supprime les points
      }}
    >
      <li onClick={() => handleOptionClick("/louer")}>Résidentiel</li>
      <li onClick={() => handleOptionClick("/commercial")}>Commercial</li>
    </ul>
  )}
</div>

										{/* Type de transaction */}
										<div ref={rentDropdownRef} style={{ position: "relative", display: "inline-block" }}>
  <button
    onClick={handleRentClick}
    style={{
      padding: "10px 20px",
      backgroundColor: "white",
      color: "black",
      border: "none",
      borderRadius: "30px", // Ajout d'une bordure arrondie
      cursor: "pointer",
      display: "flex",
      border: "1px solid #ddd",
      alignItems: "center",
      gap: "10px", // Espace entre le texte et l'icône
    }}
  >
    Louer
    <span
  style={{
    transform: isResidentialOpen ? "rotate(180deg)" : "rotate(0deg)",
    fontWeight: "300", // Plus léger
    fontSize: "12px", // Plus petit
    lineHeight: "1", // Ajuster la hauteur de ligne
  }}
>
  ▼
</span>
  </button>
  {isRentOpen && (
    <ul
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        backgroundColor: "white",
        padding: "10px",
        border: "1px solid #ddd",
        zIndex: 1000,
        listStyleType: "none", // Supprime les points
      }}
    >
      <li onClick={() => handleOptionClick("/louer")}>À louer</li>
      <li onClick={() => handleOptionClick("/vendre")}>À vendre</li>
    </ul>
  )}
</div>

										{/* Prix */}
										{/* Prix */}
										<button className="button-style" style={{
    color: 'black', // Texte en noir
  }}
  
										
  onClick={() => setIsPriceFilterOpen(!isPriceFilterOpen)}
										>
										<span className="prix-text">Prix</span>
										</button>



            {isPriceFilterOpen && (
              <div ref={cardRef} className="price-filter-card" style={{ marginTop: "15px", marginRight: "-10px" }} >
                <h4>Prix</h4>
                <Slider
                  range
                  value={priceRange}
                  min={0}
                  max={10000}
                  step={100}
                  onChange={(value) => setPriceRange(value)}
                />
                <div className="price-inputs">
                  <div className="price-input">
                    <span>{priceRange[0].toLocaleString()} </span>
                  </div>
                  <div className="price-input">
                    <span>{priceRange[1].toLocaleString()}</span>
                  </div>
                </div>
                <div className="filter-buttons">
                  <button
                    className="close-button"
                    onClick={() => setIsPriceFilterOpen(false)}
                  >
                    Fermer
                  </button>
                  <button
  className="apply-button"
  onClick={handleApplyFilter} // Assurez-vous que la fonction est correcte
>
  Appliquer
</button>

                </div>
              </div>
            )}





										{/* Filtres */}
                    <button
  className="button-style" style={{
    color: 'black', // Texte en noir
  }}
  
  onClick={handleToggleFilterModal}
>
  Filtres
</button>


      {/* Modal pour les filtres */}
      {isFilterModalOpen && (
        <div ref={filterModalRef} className="filter-modal" style={{ marginTop: '-260px', marginLeft: '200px' }}>
          {/* <h4 className="filter-modal-title">Filtres</h4> */}
          <div className="filter-options">
          <div className="filter-item">
            <div className="filter-item-header">
              <span className="filter-item-title">Type d'habitat</span>
              <button
                className="expand-button"
                onClick={handleTogglePropertyType}
              >
                {isPropertyTypeOpen ? "-" : "+"}
              </button>
            </div>
            {isPropertyTypeOpen && (
              <div className="checkbox-group">
                <div>
                <label>
    <input
      type="checkbox"
      value="appartement"
      onChange={() => handlePropertyTypeChange("appartement")}
      checked={selectedPropertyTypes.includes("appartement")}
    />
    Appartement
  </label>
                          <label>
                            <input
                              type="checkbox"
                              onChange={() => handleFilterChange("bureau_commerce")}
                              checked={selectedPropertyTypes.includes("bureau_commerce")}
                            />
                            Bureau / Commerce
                          </label>

                          <label>
                            <input
                              type="checkbox"
                              onChange={() => handleFilterChange("hotel_restaurant")}
                              checked={selectedPropertyTypes.includes("hotel_restaurant")}
                            />
                            Hotel / Restaurant
                          </label>
                  
                </div>
                <div>
                <label>
                            <input
                              type="checkbox"
                              onChange={() => handleFilterChange("studio_chambre")}
                              checked={selectedPropertyTypes.includes("studio_chambre")}
                            />
                            Studio / Chambre
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              onChange={() => handleFilterChange("villa_maison")}
                              checked={selectedPropertyTypes.includes("villa_maison")}
                            />
                            Villa / Maison
                          </label>
                  <label>
                            <input
                              type="checkbox"
                              onChange={() => handleFilterChange("terrain")}
                              checked={selectedPropertyTypes.includes("terrain")}
                            />
                            Terrain
                          </label>

                  
                </div>
              </div>
            )}
          </div>
          <div className="filter-item">
            <div className="filter-item-header">
              <span className="filter-item-title">Caractéristiques</span>
              <button
                className="expand-button"
                onClick={handleToggleCharacteristics}
              >
                {isCharacteristicsOpen ? "-" : "+"}
              </button>
            </div>
            {isCharacteristicsOpen && (
              <div className="characteristics-content">
                {/* Menus déroulants */}
               

                {/* Cases à cocher */}
                {isCharacteristicsOpen && (
            <div className="checkbox-group">
            <label>
              <input
                type="checkbox"
                value="Bord de l'eau"
                checked={selectedStructureTypes.includes("Bord de l'eau")}
                onChange={handleStructureTypeChange}
              />
              Bord de l'eau
            </label>
            <label>
              <input
                type="checkbox"
                value="Accès à l'eau"
                checked={selectedStructureTypes.includes("Accès à l'eau")}
                onChange={handleStructureTypeChange}
              />
              Accès à l'eau
            </label>
            <label>
              <input
                type="checkbox"
                value="Plan d'eau navigable"
                checked={selectedStructureTypes.includes("Plan d'eau navigable")}
                onChange={handleStructureTypeChange}
              />
              Plan d'eau navigable
            </label>
            <label>
              <input
                type="checkbox"
                value="Villégiature"
                checked={selectedStructureTypes.includes("Villégiature")}
                onChange={handleStructureTypeChange}
              />
              Villégiature
            </label>
          </div>
          
          )}

              </div>
            )}
          </div>
        
          <div className="filter-item">
  <div className="filter-item-header">
    <span className="filter-item-title">Autres Critères</span>
    <button
      className="expand-button"
      onClick={handleToggleOtherCriteria}
    >
      {isOtherCriteriaOpen ? "-" : "+"}
    </button>
  </div>

  {isOtherCriteriaOpen && (
    <div className="other-criteria-content">
      {/* Superficie du terrain */}
      <div className="criteria-inputs">
        <label>
          Superficie du terrain (m²)
          <div className="input-group">
            <input
              type="number"
              placeholder="Min (m²)"
              value={minLotSize}
              onChange={(e) => setMinLotSize(e.target.value)}
              className="input-box"
            />
            <span>à</span>
            <input
              type="number"
              placeholder="Max (m²)"
              value={maxLotSize}
              onChange={(e) => setMaxLotSize(e.target.value)}
              className="input-box"
            />
          </div>
        </label>
      </div>

      {/* Date d'ajout */}
      <div className="criteria-dates">
        <label>
          Nouveau depuis
          <div className="input-group">
            <input
              type="date"
              value={minDate}
              onChange={(e) => setMinDate(e.target.value)}
              className="input-box"
            />
            <span className="calendar-icon">📅</span>
          </div>
        </label>
      </div>
    </div>
  )}
</div>

          </div>
          <div className="filter-actions">
          <button 
            className="filter-button-common reset-button"
            onClick={handleResetFilters} // Ajout de l'événement onClick
          >
            Réinitialiser
          </button>
            <button className="filter-button-common close-button" onClick={handleToggleFilterModal}>
              Fermer
            </button>
          </div>
          <br/>
          <button
  className="search-btton"
  onClick={() => {
    if (selectedPropertyTypes.length > 0 || selectedStructureTypes.length > 0) {
      handleSearch(); // 🔹 Exécuter seulement si des types d'habitat ou caractéristiques sont sélectionnés
    }

    if (minLotSize || maxLotSize || minDate) {
      handleSearch1(); // 🔹 Exécuter seulement si des critères avancés sont sélectionnés
    }
  }}
  style={{
    backgroundColor: "#975D23",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  }}
>
  Rechercher
</button>



        </div>
      )}

										{/* Style de vie */}
										{/* <button
										className="button-style"
										onClick={() => alert("Ouvrir les options de style de vie")}
										>
										Style de vie ({lifestyleFilters})
										</button> */}
									</div>
									</div>
									
									{query.length >= 3 && (
  <>
    {suggestions.length > 0 ? (
      <div className="search-results-container">
        {suggestions.map((item, index) => (
          <div
            key={index}
            className="result-card"
            onClick={() => handleCardClick(item)} // Action sur clic
          >
            <div className="result-card-content">
              <h5>{item}</h5>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="search-results-container">
        <div className="result-card">
          <div className="result-card-content">
            <h5 style={{ color: "red" }}>Aucun Résultat</h5>
          </div>
        </div>
      </div>
    )}
  </>
)}


									 {/* Barre des onglets */}
									 <div className="tabs-container">
										<div className="tabs">
				<Link to="/louer" className={`tab-button ${activeTab === 'galerie' ? 'active' : ''}`} onClick={() => handleTabClick('galerie')}>
					<FontAwesomeIcon icon={faImages} /> Galerie
				</Link>
				<Link to="/carte" className={`tab-button ${activeTab === 'carte' ? 'active' : ''}`} onClick={() => handleTabClick('carte')}>
					<FontAwesomeIcon icon={faMapMarkedAlt} /> Carte
				</Link>
				<Link to="/sommaire" className={`tab-button ${activeTab === 'sommaire' ? 'active' : ''}`} onClick={() => handleTabClick('sommaire')}>
					<FontAwesomeIcon icon={faListAlt} /> Sommaire
				</Link>
				<div className="tab-indicator" style={{ left: `${getIndicatorPosition(activeTab)}%` }}></div>
				</div>

                {/* Nombre de propriétés trouvées */}
                <span className="properties-found">{results.length} propriétés trouvées</span>

                {/* Trier par */}
                <div ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: "10px 20px",
          backgroundColor: "white",
          color: "black",
          border: "1px solid #ddd",
          borderRadius: "20px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "200px", // Largeur fixe
        }}
      >
        {sortMethod === "recent"
          ? "Publication récente"
          : sortMethod === "price_asc"
          ? "Prix croissant"
          : "Prix décroissant"}
        <span
          style={{
            marginLeft: "10px",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            fontWeight: "300",
            fontSize: "12px",
          }}
        >
          ▼
        </span>
      </button>

      {isOpen && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            backgroundColor: "white",
            listStyleType: "none",
            padding: "10px",
            margin: 0,
            border: "1px solid #ddd",
            zIndex: 1000,
            borderRadius: "10px",
            width: "200px",
          }}
        >
          <li
            style={{
              padding: "10px",
              cursor: "pointer",
              borderBottom: "1px solid #ddd",
            }}
            onClick={() => {
              setSortMethod("recent");
              setIsOpen(false);
            }}
          >
            Publication récente
          </li>
          <li
            style={{
              padding: "10px",
              cursor: "pointer",
              borderBottom: "1px solid #ddd",
            }}
            onClick={() => {
              setSortMethod("price_asc");
              setIsOpen(false);
            }}
          >
            Prix croissant
          </li>
          <li
            style={{
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              setSortMethod("price_desc");
              setIsOpen(false);
            }}
          >
            Prix décroissant
          </li>
        </ul>
      )}
    </div>
            </div>

            {/* Pagination */}
            <div className="pagination-container">
                <button
                    className="pagination-button"
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                >
                    «
                </button>
                <button
                    className="pagination-button"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    ‹
                </button>
                <span className="pagination-info">
                    {currentPage} / {Math.ceil(totalProperties / propertiesPerPage)}
                </span>
                <button
                    className="pagination-button"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === Math.ceil(totalProperties / propertiesPerPage)}
                >
                    ›
                </button>
                <button
                    className="pagination-button"
                    onClick={() => handlePageChange(Math.ceil(totalProperties / propertiesPerPage))}
                    disabled={currentPage === Math.ceil(totalProperties / propertiesPerPage)}
                >
                    »
                </button>
            </div>
	<br/>
	<br/>
	<br/>
									{/* ltn__product-item */}
                  <div className="row">
  <div className="col-lg-12">
    <div className="tab-content">
      <div className="tab-pane fade active show" id="liton_product_grid">
        <div className="ltn__product-tab-content-inner ltn__product-grid-view">
          <div className="row">
            {/* Vérification et affichage des produits */}
            {results.length > 0 ? (
              results.map((product) => (
                <div key={product._id} className="col-lg-3 col-sm-6 col-12">
                  <div className="result-card">
                    {/* Image principale avec redirection */}
                    <div
                      className="image-container"
                      onClick={() => handleProductClick(product._id)}
                    >
                      <img
                        src={product.images?.[0] || '/path/to/default-image.jpg'}
                        alt={product.title || "Image indisponible"}
                        className="property-image"
                      />
                      {/* Icône avec compteur de photos */}
                      <div
                        className="icon-wrapper"
                        onClick={(e) => {
                          e.stopPropagation(); // Évite la redirection lors du clic sur l'icône
                          handleImageClick(product._id);
                        }}
                      >
                        <FontAwesomeIcon icon={faCamera} className="photo-icon" />
                        <span className="photo-count">
                          {product.images?.length || 0}
                        </span>
                      </div>
                    </div>

                    {/* Détails du produit */}
                    <div className="property-details">
                    <h3>{product.title || "Titre indisponible"}</h3>
      <p>{product.address || "Adresse inconnue"}, {product.city || "Ville inconnue"}</p>
      <p>Prix : {product.price ? `${product.price} FCFA` : "Non spécifié"}</p>
                      <div className="features">
                        <span>
                          <FontAwesomeIcon icon={faBed} />{" "}
                          {product.features?.bedrooms || 0} 
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faBath} />{" "}
                          {product.features?.bathrooms || 0} 
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-results">Aucun résultat trouvé.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


								
									</div>
								</div>
								</div>
								
							</div>
							
							</div>
						</div>
				</div>
			</div>
						
			


			</div>
			)
			function getIndicatorPosition(tab) {
				switch (tab) {
				  case 'galerie':
					return 0;
				  case 'carte':
					return 33.33;
				  case 'sommaire':
					return 66.66;
				  default:
					return 0;
				}
			  }
        
}

export default ResultsPagebox